import { render, staticRenderFns } from "./FlexSpan.vue?vue&type=template&id=04351b66&"
import script from "./FlexSpan.vue?vue&type=script&lang=js&"
export * from "./FlexSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports